export const dictionaries = [
    {
        key: 'myaddresses',
        label: 'Мои адреса',
        createBtnText: 'Добавить новый адрес',
        columns: [
            {
                fieldName: 'address',
                type: 'linkToCard',
                title: 'Адрес',
                disableSort: false,
                filterType: 'text',
                fieldType: 'address',
                fieldWidth: '100%',
                isRequired: true
            },
            {
                fieldName: 'contactName',
                type: 'contactName',
                title: 'Контактное лицо',
                disableSort: false,
                fieldType: 'text',
                filterType: 'text',
                isRequired: true
            },
            {
                fieldName: 'companyName',
                type: 'companyName',
                title: 'Компания',
                disableSort: false,
                fieldType: 'text',
                filterType: 'text',
            },
            {
                fieldName: 'contactPhone',
                type: 'contactPhone',
                title: 'Телефон',
                disableSort: false,
                fieldType: 'phone',
                filterType: 'text',
                isRequired: true,
                info: 'Номер телефона с кодом страны, например: +79991234567',
                fieldWidth: '20%',
            },
            {
                fieldName: 'additionalPhone',
                type: 'additionalPhone',
                title: 'Добавочный',
                disableSort: false,
                fieldType: 'text',
                filterType: 'text',
                fieldWidth: '13.3%',
            },
            {
                fieldName: 'comment',
                type: 'comment',
                title: 'Комментарий к адресу',
                disableSort: false,
                filterType: 'text',
                fieldType: 'text',
                fieldWidth: '100%',
                maxLength: '100',
                info: '100 символов - максимальная длина комментария, которую принимают курьерские службы'
            },
            {
                fieldName: 'source',
                type: 'source',
                title: 'Источник',
                disableSort: false,
                filterType: 'selectMultiple',
                fieldType: 'text',
                block: 1,
                fieldWidth: '50%',
                hiddenForNew: true,
                disabledForEdit: true,
                optionsUrl: 'myaddresses/allsourcetypes',
            },
            {
                fieldName: 'dateLastUse',
                type: 'date',
                title: 'Дата последнего использования',
                disableSort: false,
                filterType: 'date',
                fieldType: 'dateTimeDisabled',
                block: 1,
                fieldWidth: '50%',
                hiddenForNew: true,
                disabledForNew: true,
                disabledForEdit: true
            },
            {
                fieldName: 'userLogin',
                type: 'userLogin',
                title: 'Пользователь',
                disableSort: false,
                fieldType: 'text',
                filterType: 'text',
                hiddenForNew: true,
                disabledForNew: true,
                disabledForEdit: true
            },
            {
                fieldName: 'companyId',
                type: 'company',
                title: 'Юр. лицо',
                disableSort: false,
                filterType: 'selectMultiple',
                fieldType: 'select',
                block: 1,
                fieldWidth: '50%',
                optionsUrl: 'admin/rates/ref/allcompanies',
                rolesForView: ['Admin', 'GlobalAdmin'],
                rolesForEdit: ['Admin', 'GlobalAdmin'],
                isRequired: true
            }
        ]
    }
]


// WEBPACK FOOTER //
// ./App/pages/dictionaries/dictionaries.js